export default "__VITE_ASSET__Bwx$llhk__"